<template>
  <PaymentMethodLayer
    :paymentMethod="paymentMethod"
    :paymentMethodOptions="paymentMethodOptions"
    :onPaymentMethod="changePaymentMethod"
  />
</template>

<script>
import PaymentMethodLayer from '../../layouts/templates/PaymentMethodLayer'

export default {
  name: 'PaymentMethodLayerContainer',
  components: {
    PaymentMethodLayer
  },
  computed: {
    paymentMethod() {
      return this.$store.getters['preOrder/paymentMethod']
    },
    paymentMethodOptions() {
      return this.$store.getters['preOrder/paymentMethodOptions']
    },
    paymentMethodModal() {
      return this.$store.getters['preOrder/paymentMethodModal']
    }
  },
  methods: {
    changePaymentMethod(paymentMethod) {
      this.$store.commit('preOrder/setPaymentMethod', paymentMethod)
    }
  }
}
</script>